import Nav from "./Nav";
import "./Header.css";

function Header() {
  return (
    <header>
      <h1>DungeonBox</h1>
      <Nav />
    </header>
  );
}

export default Header;
